const claimStatusCategories = [
  'Sent',
  'Success',
  'Error',
  'Unsent'
];

export default claimStatusCategories;



// WEBPACK FOOTER //
// ./src/config/claimStatusCategories.js